import { render } from "./TheaterResources.vue?vue&type=template&id=0369c362"
import script from "./TheaterResources.vue?vue&type=script&lang=js"
export * from "./TheaterResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__